export const NON_BOOLEAN_VALUE = 'non_boolean';